// Observe successful YX checkout creation. Preserve the original request/promise.
(() => {
  if (window.__stalempGoogleCheckoutBridge) return;
  const state = window.__stalempGoogleCheckoutBridge = { version: 1, attached: false };
  const seen = new Set();
  function observe(path, response) {
    if (!/^\/api\/checkout(?:\/(?:credit|paypal|google|apple))?$/.test(String(path))) return;
    const data = response?.data;
    if (!data?.checkoutId || !Array.isArray(data.cart?.items) || !data.cart.items.length) return;
    const checkoutId = String(data.checkoutId);
    if (seen.has(checkoutId)) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    seen.add(checkoutId);
    const money = data.costs;
    const detail = { source: 'yx_checkout_success', checkoutId };
    if (money?.subtotal != null && Number.isFinite(Number(money.subtotal))) detail.value = Number(money.subtotal);
    if (/^[A-Z]{3}$/.test(money?.currencyCode || '')) detail.currency = money.currencyCode;
    try {
      Promise.resolve(publish.call(window.Shopify.analytics, 'stalemp_yx_checkout_started', detail)).catch(() => {});
    } catch (_) { /* Tracking must never interrupt checkout. */ }
  }
  function attach() {
    const request = window.yxRequest;
    if (!request || typeof request.post !== 'function') return false;
    const original = request.post;
    if (original.__stalempGoogleBridge) return true;
    function post() {
      const result = Reflect.apply(original, this, arguments);
      const path = arguments[0];
      if (/^\/api\/checkout(?:\/(?:credit|paypal|google|apple))?$/.test(String(path))) {
        Promise.resolve(result).then(response => { try { observe(path, response); } catch (_) {} }, () => {});
      }
      return result;
    }
    Object.defineProperty(post, '__stalempGoogleBridge', { value: true });
    request.post = post;
    state.attached = true;
    return true;
  }
  if (!attach()) {
    let attempts = 0;
    const timer = setInterval(() => { if (attach() || ++attempts >= 120) clearInterval(timer); }, 500);
  }
})();
